import { map, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

import {
  UserType,
  UpdateUserGQL,
  UserUpdateInput,
  UpdateCurrentUserGQL,
  UserEventsSourceEnum,
  CurrentUserCompleteGQL,
  UpdateCurrentUserPasswordForAppGQL,
} from '@sifca-monorepo/ecommerce-generator';
import { FetchPolicy } from '@apollo/client/core';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private user: ReplaySubject<UserType> = new ReplaySubject<UserType>(1);
  private currentUser: ReplaySubject<UserType> = new ReplaySubject<UserType>(1);

  set user$(value: any) {
    this.user.next(value);
  }
  get user$(): Observable<UserType> {
    return this.user.asObservable();
  }

  get currentUser$(): Observable<UserType> {
    return this.currentUser.asObservable();
  }
  set currentUser$(value: any) {
    this.currentUser.next(value);
  }

  constructor(
    private updateUserGQL: UpdateUserGQL,
    private updateCurrentUserGQL: UpdateCurrentUserGQL,
    private currentUserCompleteGQL: CurrentUserCompleteGQL,
    private updateCurrentUserPasswordForAppGql: UpdateCurrentUserPasswordForAppGQL,
  ) {}

  get(): Observable<UserType> {
    return this.currentUserCompleteGQL.fetch().pipe(
      tap((response: any) => {
        this.user.next(response.data.currentUserComplete);
      }),
    );
  }

  updateCurrentUser(input: UserUpdateInput): Observable<UserType> {
    return this.updateCurrentUserGQL.mutate({ input, source: UserEventsSourceEnum.WEB }).pipe(
      map(({ data }: any) => {
        this.currentUser.next(data.updateCurrentUser);
        return data.updateCurrentUser;
      }),
    );
  }

  getCurrentUser(fetchPolicy: FetchPolicy = 'network-only'): Observable<UserType> {
    return this.currentUserCompleteGQL.fetch({}, { fetchPolicy }).pipe(
      map(({ data }: any) => {
        this.currentUser.next(data?.currentUserComplete);
        return data?.currentUserComplete;
      }),
    );
  }

  /**
   * Update the user
   *
   */
  update(input: UserUpdateInput, id: string): Observable<any> {
    return this.updateUserGQL.mutate({ id, input, source: UserEventsSourceEnum.WEB }).pipe(
      map((response: any) => {
        this.user.next(response.data.updateUser);
      }),
    );
  }

  updatePassword(oldPassword: string, newPassword: string): Observable<any> {
    return this.updateCurrentUserPasswordForAppGql.mutate({ oldPassword, newPassword });
  }

  logout(): void {
    this.user.next(null);
  }
}
